<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
   Chart as ChartJS,
   Title,
   Tooltip,
   Legend,
   LineElement,
   LinearScale,
   CategoryScale,
   PointElement
} from 'chart.js'

ChartJS.register(
   Title,
   Tooltip,
   Legend,
   LineElement,
   LinearScale,
   CategoryScale,
   PointElement
)

export default {
   name: 'LineChart',
   components: {
      LineChartGenerator
   },
   props: {
      chartId: {
         type: String,
         default: 'line-chart'
      },
      datasetIdKey: {
         type: String,
         default: 'label'
      },
      width: {
         type: Number,
         default: 400
      },
      height: {
         type: Number,
         default: 400
      },
      cssClasses: {
         default: '',
         type: String
      },
      styles: {
         type: Object,
         default: () => {}
      },
      plugins: {
         type: Array,
         default: () => []
      },
      chartData: {
         type: Object,
         default: function () {
            return {
               labels: [

               ],
               datasets: [
                  {
                     //  label: 'Data One',
                     //  backgroundColor: '#e51f85',
                     //  borderColor: '#e51f85',
                     //  data: [40, 39, 10, 40, 39, 80, 40]
                  }
               ]
            }
         }
      }
   },
   data () {
      return {
         chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
               y: {
                  ticks: {
                     fontSize: 18,
                     callback: function (label, index, labels) {
                        return label + ' €'
                     }
                  }
               }
            }
         }
      }
   }
}
</script>
